import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterConstants } from './core/constants/router.constants';
import { LayoutsComponent } from './layouts/layouts.component';
import { AuthGuardService } from './core/services/auth-guard.service';

const routes: Routes = [
{ path: RouterConstants.auth, loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule), },
{ path: RouterConstants.default, redirectTo: '/' + RouterConstants.auth + '/' + RouterConstants.client, pathMatch: 'full' },
{
  path: RouterConstants.layoutContainer, component: LayoutsComponent, canActivate: [AuthGuardService],
  children: [
    { path: RouterConstants.default, redirectTo: RouterConstants.userProfile.default, pathMatch: "full" },
    { path: RouterConstants.userProfile.default, loadChildren: () => import('./features/features.module').then(mod => mod.FeaturesModule) },

  ]
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
